import { render, staticRenderFns } from "./MenuPolice.vue?vue&type=template&id=082f0907"
import script from "./MenuPolice.vue?vue&type=script&lang=js"
export * from "./MenuPolice.vue?vue&type=script&lang=js"
import style0 from "./MenuPolice.vue?vue&type=style&index=0&id=082f0907&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports